import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { insuranceAgreementsAPI } from "api/api/insuranceAgreementsApi/insuranceAgreementsApi";
import { toast } from "react-toastify";

interface PostPurchaseInsurancesRes {
  paymentId: number,
  paymentUrl: string
}

interface PostPurchaseInsurancesBody {
  marathonId: number,
}

export const postPurchaseInsurances = createAsyncThunk<
  PostPurchaseInsurancesRes,
  PostPurchaseInsurancesBody
>("insurances/postInsurances", async (body, { rejectWithValue }) => {
  try {
    const data = await insuranceAgreementsAPI.postPurchaseInsurances(body);
    if (data.paymentUrl === null) {
      window.location.reload();
    } else if (data.paymentUrl) {
      window.location.href = data.paymentUrl;
    }
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      const errorMessage =
        (error.response?.data as { message?: string })?.message ||
        "Error while buying insurances";
      toast.error(errorMessage);
      console.error("Error while creating insurances", error.response?.data);
      return rejectWithValue(error.response?.data || "Unknown error");
    } else {
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});
